import useSWRFetcher, { SWRFetchError } from "../commonly-stored/fetcher";
import { useCallback } from "react";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { InventoryItem, InventoryItemType } from "./useInventoryItems";

export interface InventoryItemsResponse {
  inventory_items: InventoryItem[];
}

// only used for selects, eventually should create a search endpoint
export default function useAllInventoryItems(itemType: InventoryItemType) {
  const fetcher = useSWRFetcher<InventoryItemsResponse>();

  const {
    data: inventoryItemsResponse,
    mutate,
    error,
  } = useSWR<InventoryItemsResponse, SWRFetchError>(
    `${settings.api_url}/inventory/items/all?item_type=${itemType}`,
    fetcher,
  );

  const refreshBins = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    items: inventoryItemsResponse || null,
    errored: error !== undefined,
    refreshBins,
  };
}
